export default __webpack_public_path__ + "static/media/Ice_and_Chrome_LE.8f9e2624.jpg";